/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class UpdateSubscriptionCountRequest {
    'contract': string;
    'token_id': number;
    'count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "token_id",
            "baseName": "token_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return UpdateSubscriptionCountRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
